var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup505(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.022,
    height: 20,
    viewBox: "0 0 18.022 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(295.915 -135.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M-284.895,291.007a5.482,5.482,0,0,1-1.551,3.93c-1.11,1.136-2.246,2.247-3.374,3.366a.749.749,0,0,1-1.157,0c-1.117-1.108-2.25-2.2-3.339-3.335a5.257,5.257,0,0,1-1.361-5.365,5.261,5.261,0,0,1,3.972-3.828,5.478,5.478,0,0,1,6.734,4.5C-284.929,290.561-284.911,290.843-284.895,291.007Zm-5.509-1.183a1.237,1.237,0,0,0-1.252,1.244,1.247,1.247,0,0,0,1.238,1.261,1.253,1.253,0,0,0,1.267-1.259A1.247,1.247,0,0,0-290.4,289.824Z",
    transform: "translate(0 -142.716)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M-155.881,146.963a.819.819,0,0,1-.492.841.7.7,0,0,1-.854-.245,1.372,1.372,0,0,1-.179-.568,10.393,10.393,0,0,0-6.962-9.047,9.629,9.629,0,0,0-2.81-.589.752.752,0,0,1-.71-.8.768.768,0,0,1,.831-.685,11.711,11.711,0,0,1,4.49,1.222,11.879,11.879,0,0,1,6.407,8.191C-156.03,145.831-155.972,146.4-155.881,146.963Z",
    transform: "translate(-122.012 0)",
    fill: "#febaba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3807",
    "data-name": "Path 3807",
    d: "M-159.312,217.738a.738.738,0,0,1-.637.817.713.713,0,0,1-.832-.636,7.276,7.276,0,0,0-.638-2.338,6.883,6.883,0,0,0-5.474-3.99c-.371-.053-.717-.123-.868-.521a.744.744,0,0,1,.764-1,8.363,8.363,0,0,1,5.542,2.78,8.386,8.386,0,0,1,2.13,4.7C-159.316,217.623-159.315,217.694-159.312,217.738Z",
    transform: "translate(-122.09 -70.719)",
    fill: "#febaba"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup505);
export default __webpack_public_path__ + "static/media/Group 505.15f1deab7186a1686a49e988a943332c.svg";
export { ForwardRef as ReactComponent };